/**
 * Shared Axios configuration module.
 * 
 * Centralizes axios defaults configuration to avoid duplication
 * across multiple entry points (app.js, dashboard.js, listings.js).
 */

import axios from 'axios';

/**
 * Configure axios defaults with CSRF token and JSON headers.
 * Call this once in your entry point after Laravel global is available.
 */
export function setupAxios() {
    // Ensure Laravel global exists
    if (typeof Laravel === 'undefined') {
        console.warn('Laravel global not found. CSRF token may not be set.');
        return;
    }

    axios.defaults.headers.common = {
        'X-CSRF-TOKEN': Laravel.csrfToken,
        'Accept': 'application/json'
    };
}

/**
 * Get configured axios instance.
 * Use this if you need a reference to axios with defaults already set.
 */
export function getAxios() {
    return axios;
}

export default axios;
